import SchoologySettings from './SchoologySettings';

export default SchoologySettings;
